import React from "react";
import { object, string, number, bool } from "prop-types";

import CollectionName from "../collection-name";
import TitleWithBorder from "../title-with-border";

const CollectionTitleHeader = ({ collection, name, index, defaultBorder = false, hasDarkBg = false }) => {
  const collectionName = collection.metadata?.["display-name"] || collection.name;
  if (defaultBorder) {
    return <CollectionName collection={collection} />;
  } else {
    return index === 0 || index === 1 ? (
      <TitleWithBorder name={collectionName} />
    ) : (
      <CollectionName collection={collection} hasDarkBg={hasDarkBg} />
    );
  }
};

CollectionTitleHeader.propTypes = {
  collection: object,
  name: string,
  index: number,
  defaultBorder: bool
};

export default CollectionTitleHeader;
